export const PLAY_BUTTON_SIZE = 2.3;
export const PLAY_BUTTON_SIZE_UNIT = 'rem';
export const PLAY_BUTTON_BOX_SHADOW_OUTER_OPACITY = 0.08;
export const PLAY_BUTTON_BOX_SHADOW_INNER_OPACITY = 0.11;
